import { useState, useEffect } from "react";
import api from "../services/api";
import { Link, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import '../css/tablasCeldas.css' //No funciona, investigar IST: 2

const AddPersonaData = () => {
  const { IdPersona } = useParams();
  const [comorbilidadesPersona, setComorbilidadesPersona] = useState("");
  const [comorbilidadesNoPersona, setComorbilidadesNoPersona] = useState([]);
  const [mostrarDescripcion, setMostrarDescripcion] = useState({});
  const [allPatologias, setAllPatologias] = useState([]);
  const [IdPatologia1, setIdPatologia1] = useState("");
  const [IdPatologia2, setIdPatologia2] = useState("");
  const [patologiasPersona, setPatologiasPersona] = useState([]);
  const [searchTerm, setSearch] = useState("");


  useEffect(() => {
    getComorbilidadesXPersonas();
    getComorbilidadesNoXPersonas();
    getPatologias();
  }, []);

  const getPatologias = async () => {
    try {
      const response = await api.get(`/patologias`);
      setAllPatologias(response.data);
    } catch (error) {
      console.error("Error al obtener todas las patologías: " + error.message);
    }
  };

  const getComorbilidadesXPersonas = async () => {
    const response = await api.get(`/comorbilidadesPer/${IdPersona}`);
    setComorbilidadesPersona(response.data[0]);
    console.log(response.data[0]);
  };

  const getComorbilidadesNoXPersonas = async () => {
    const response = await api.get(`/comorbilidadesNoPer/${IdPersona}`);
    setComorbilidadesNoPersona(response.data);
  };

  const createComorbilidadPorPersona = async (IdComorbilidad) => {
    try {
      const response = await api.post(`/comorbilidadpersona`, {
        IdPersona,
        IdComorbilidad,
        IdPatologia: IdPatologia1
      });

      console.log(response.data);
      getComorbilidadesXPersonas();
      getComorbilidadesNoXPersonas();
    } catch (error) {
      console.error('Error al obtener datos:', error);
    }
  };

  // Init Config 'ColumnasCOmorbilidades'
  const widthType = 'vw';
  const tamIdColumas = '5';
  const tamNombre = '9';
  const tamDescripcion = '16.5';
  const tamButtonEliminar = '7';

  const tamLimitCharacters = 17;
  // Fin Config

  const columnasComorbilidades = [
    {
      name: 'id',
      selector: row => row.IdComorbilidad,
      sortable: true,
      width: tamIdColumas + widthType,
    },
    {
      name: 'Nombre',
      selector: row => row.Nombre,
      sortable: true,
      width: tamNombre + widthType,
    },
    {
      name: 'Descripción',
      cell: (row) => {
        const toggleDescripcion = () => {
          setMostrarDescripcion({ ...mostrarDescripcion, [row.IdComorbilidad]: !mostrarDescripcion[row.IdComorbilidad] });
        };

        const descripcion = row.Descripcion || "Sin descripción";
        const mostrarBoton = row.Descripcion && row.Descripcion.length > tamLimitCharacters;

        const estiloCelda = {
          display: 'flex',
          alignItems: 'center',
          width: '30vw',
          maxHeight: mostrarDescripcion[row.IdComorbilidad] ? 'none' : '40vh',
          overflow: mostrarDescripcion[row.IdComorbilidad] ? 'visible' : 'hidden',
        };

        const estiloContenido = {
          flex: 1,
          maxHeight: '40vh',
          textOverflow: mostrarDescripcion[row.IdComorbilidad] ? 'clip' : 'ellipsis',
          whiteSpace: mostrarDescripcion[row.IdComorbilidad] ? 'normal' : 'nowrap',
        };

        return (
          <div style={estiloCelda}>
            <div style={estiloContenido}>
              {!mostrarDescripcion[row.IdComorbilidad] ? (descripcion.length > tamLimitCharacters ? descripcion.substring(0, tamLimitCharacters) + '...' : descripcion) : descripcion}
            </div>
            {mostrarBoton && (
              <button className="btn" onClick={(e) => {
                toggleDescripcion();
                e.preventDefault();
              }}>
                {mostrarDescripcion[row.IdComorbilidad] ? "Ver Menos" : "Ver Más"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: tamDescripcion + widthType,
    },
    {
      name: '',
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={(e) => {
            e.preventDefault();
            /*if (IdPatologia) {
              dropComorbilidadPorPatologia(row.IdComorbilidad);
            } else {
              console.log("Selecciona una patología válida.");
            }*/
          }}
        >
          Eliminar
        </button >
      ),
      width: tamButtonEliminar + widthType,
    }
  ];

  // Init Config 'columnasComorbilidadesAgregar'
  const widthType2 = 'vw';
  const tamIdColumas2 = '5';
  const tamNombre2 = '9';
  const tamDescripcion2 = '17';
  const tamButtonEliminar2 = '7';

  const tamLimitCharacters2 = 22;
  // Fin Config


  const columnasComorbilidadesAgregar = [
    {
      name: 'id',
      selector: row => row.IdComorbilidad,
      sortable: true,
      width: tamIdColumas2 + widthType2,
    },
    {
      name: 'Nombre',
      selector: row => row.Nombre,
      sortable: true,
      width: tamNombre2 + widthType2,
    },
    {
      name: 'Descripción',
      cell: (row) => {
        const toggleDescripcion = () => {
          setMostrarDescripcion({ ...mostrarDescripcion, [row.IdComorbilidad]: !mostrarDescripcion[row.IdComorbilidad] });
        };

        const descripcion = row.Descripcion || "Sin descripción";
        const mostrarBoton = row.Descripcion && row.Descripcion.length > tamLimitCharacters2;

        const estiloCelda = {
          display: 'flex',
          alignItems: 'center',
          width: '30vw',
          maxHeight: mostrarDescripcion[row.IdComorbilidad] ? 'none' : '40vh',
          overflow: mostrarDescripcion[row.IdComorbilidad] ? 'visible' : 'hidden',
        };

        const estiloContenido = {
          flex: 1,
          maxHeight: '40vh',
          textOverflow: mostrarDescripcion[row.IdComorbilidad] ? 'clip' : 'ellipsis',
          whiteSpace: mostrarDescripcion[row.IdComorbilidad] ? 'normal' : 'nowrap',
        };

        return (
          <div style={estiloCelda}>
            <div style={estiloContenido}>
              {!mostrarDescripcion[row.IdComorbilidad] ? (descripcion.length > tamLimitCharacters2 ? descripcion.substring(0, tamLimitCharacters2) + '...' : descripcion) : descripcion}
            </div>
            {mostrarBoton && (
              <button className="btn" onClick={(e) => {
                toggleDescripcion();
                e.preventDefault();
              }}>
                {mostrarDescripcion[row.IdComorbilidad] ? "Ver Menos" : "Ver Más"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: tamDescripcion2 + widthType2,
    },
    {
      name: '',
      cell: (row) => (
        <button
          className="btn btn-success"
          onClick={(e) => {
            e.preventDefault();
            if (IdPatologia1) { //IST: Verificar funcionamiento del condicional
              createComorbilidadPorPersona(row.IdComorbilidad);
            }
          }}
        >
          Agregar
        </button >
      ),
      width: tamButtonEliminar2 + widthType2,
    }
  ];
  // INit Funciones relacionadas con la anterior columna: 

  const searcher = (e) => {
    setSearch(e.target.value)
  }

  return (
    <div className="columns mt-5 is-centered">
      <div className="column is-half">
        <div className="notification is-primary">
          <strong>Creación de Comorbilidades por Patologías</strong>
        </div>
        <form>
          <div className="field">
            <Link
              to={'/PrivateMainPage/casos'}
              className="button is-small is-info mr-2"
            >
              Salir
            </Link>
          </div>
          <div className="tabla-centrado">
            <div className="tabla-container">
              <div className="tabla-izquierda">
                <div className="">
                  <DataTable
                    className="tabla"
                    pagination
                    columns={columnasComorbilidades}
                    data={comorbilidadesPersona}
                  />
                </div>
              </div>
              <div className="tabla-derechaSpecial">
                <div className="table-header">
                  <div className="column table-search">
                    <input type="text" name="searchTerm" id="searchTerm" onChange={searcher} placeholder="Buscar" />
                  </div>
                  <div className="container text-top">
                    <select
                      className="select is-fullwidth"
                      value={IdPatologia1}
                      onChange={(e) => setIdPatologia1(e.target.value)}>
                      <option value="">Seleccione Patología</option>
                      {allPatologias.map((patologia) => (
                        <option key={patologia.IdPatologia} value={patologia.IdPatologia}>
                          {patologia.Nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="table-top">
                  <DataTable
                    pagination
                    paginationPerPage={2}
                    paginationRowsPerPageOptions={[2, 3, 4, 5]}
                    columns={columnasComorbilidadesAgregar}
                    data={comorbilidadesNoPersona.filter((item) =>
                      item.Nombre.toLowerCase().includes(searchTerm.toLowerCase())
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="tabla-container espaciadoSuperior">
              <div className="tabla-izquierda">
                <div className="">
                  <DataTable
                    className="tabla"
                    pagination
                    columns={columnasComorbilidades}
                    data={comorbilidadesPersona}
                  />
                </div>
              </div>
              <div className="tabla-derechaSpecial">
                <div className="table-header">
                  <div className="column table-search">
                    <input type="text" name="searchTerm" id="searchTerm" onChange={searcher} placeholder="Buscar" />
                  </div>
                  <div className="container text-top">
                    <select
                      className="select is-fullwidth"
                      value={IdPatologia2}
                      onChange={(e) => setIdPatologia2(e.target.value)}>
                      <option value="">Seleccione Patología</option>
                      {allPatologias.map((patologia) => (
                        <option key={patologia.IdPatologia} value={patologia.IdPatologia}>
                          {patologia.Nombre}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="table-top">
                  <DataTable
                    pagination
                    paginationPerPage={2}
                    paginationRowsPerPageOptions={[2, 3, 4, 5]}
                    columns={columnasComorbilidadesAgregar}
                    data={comorbilidadesNoPersona.filter((item) =>
                      item.Nombre.toLowerCase().includes(searchTerm.toLowerCase())
                    )}
                  />
                </div>
              </div>
            </div>
          </div>

        </form >
      </div >
    </div >
  );
};

export default AddPersonaData;